import { useState, useEffect } from 'react';
import { Box, Flex } from '@mantine/core';
import VariableNumberInput from "../../../GlobalComponent/VariableNumberInput";

const TouchMove = (props) => {
    const [dataState, setDataState] = useState({
        startX: props?.nodeData?.data?.options?.startX ?? 0,
        startY: props?.nodeData?.data?.options?.startY ?? 0,
        endX: props?.nodeData?.data?.options?.endX ?? 0,
        endY: props?.nodeData?.data?.options?.endY ?? 0,
    });

    const handleCoordinateChange = (field, value) => {
        setDataState((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    useEffect(() => {
        props.handleSetDataBaseModal && props.handleSetDataBaseModal(dataState);
    }, [dataState, props]);

    return (
        <Box component="form" mx="auto">
            <Flex
                direction="row"
                gap="md"
                justify="flex-start"
                align="flex-start"
                wrap="wrap"
                mb="sm"
            >
                <VariableNumberInput
                    style={{ flex: 1 }}
                    label="Start X"
                    dataState={dataState.startX}
                    handleData={(value) => handleCoordinateChange("startX", value)}
                />
                <VariableNumberInput
                    style={{ flex: 1 }}
                    label="Start Y"
                    dataState={dataState.startY}
                    handleData={(value) => handleCoordinateChange("startY", value)}
                />
            </Flex>
            <Flex
                direction="row"
                gap="md"
                justify="flex-start"
                align="flex-start"
                wrap="wrap"
            >
                <VariableNumberInput
                    style={{ flex: 1 }}
                    label="End X"
                    dataState={dataState.endX}
                    handleData={(value) => handleCoordinateChange("endX", value)}
                />
                <VariableNumberInput
                    style={{ flex: 1 }}
                    label="End Y"
                    dataState={dataState.endY}
                    handleData={(value) => handleCoordinateChange("endY", value)}
                />
            </Flex>
        </Box>
    );
}

export default TouchMove;
